import { createContext, useContext } from 'react';
import { Position } from '@xyflow/react';
import type { LayoutDirection } from '../../shared/flow-graph-layout';

const FlowLayoutDirectionContext = createContext<LayoutDirection>('LR');

export function FlowLayoutDirectionProvider({
  direction,
  children,
}: {
  direction: LayoutDirection;
  children: React.ReactNode;
}) {
  return (
    <FlowLayoutDirectionContext.Provider value={direction}>
      {children}
    </FlowLayoutDirectionContext.Provider>
  );
}

export function useFlowLayoutDirection(): LayoutDirection {
  return useContext(FlowLayoutDirectionContext);
}

/** Target handle side for incoming edges. */
export function flowTargetHandlePosition(direction: LayoutDirection): Position {
  return direction === 'TB' ? Position.Top : Position.Left;
}

/** Source handle side for outgoing edges. */
export function flowSourceHandlePosition(direction: LayoutDirection): Position {
  return direction === 'TB' ? Position.Bottom : Position.Right;
}
